import React from 'react';
import user from '../../assets/img/feed-imgs/right/user.svg'
import saved from '../../assets/img/feed-imgs/right/saved.svg'
import calengar from '../../assets/img/feed-imgs/right/calendar.svg'
import reset from '../../assets/img/feed-imgs/right/reset.svg'


const ShortMenu = () => {
    const shorCurtMenu = [
       { name : user},
       { name : saved},
       { name : calengar},
       { name : reset},
    ]
    return (
        <div className="row mb-4">
            {
                shorCurtMenu.map( (item, index) => <div className="col-3 d-flex justify-content-around " key={index}>
                <button className="shortcurt-menus text-center w-100 d-flex justify-content-center p-3"  type="button"><img src={item.name} alt="" /></button>
            </div> )
            }
        </div>
    );
};

export default ShortMenu;